import React from "react";

import Map from "./Map";
import TillerPreviewLayer from "./maps/TillerPreviewLayer";

const RasterCoverageMap = ({
  id,
  minZoom,
  maxZoom,
  bounds,
  gcps,
  seamlinesUrl,
  tilesUrl,
}) => {
  return (
    <Map
      loader={false}
      bounds={bounds}
      fitBoundsOptions={{
        padding: 50,
      }}
      showLayerToggle={false}
      maxZoom={maxZoom}
    >
      <TillerPreviewLayer
        id={id}
        minZoom={minZoom}
        maxZoom={maxZoom}
        bounds={bounds}
        tilesUrl={tilesUrl}
        seamlinesUrl={seamlinesUrl}
        gcps={gcps}
      />
    </Map>
  );
};

import renderer from "../shared/renderer";
renderer(RasterCoverageMap);
